import ConsumersListHeader from './ConsumersListHeader';

export default ConsumersListHeader;
